import { FILE_SOURCES_DEPLOYMENT, PROCESS_STATUS, PROCESS_STATUS_NAME } from "src/constant/common";
import { ButtonDeploy, ButtonDetail } from "../Common/Button";
import TooltipWrapper from "../Common/TooltipWrapper";
import ShowDataCell from "../Common/DataCell";
import LabelStatus from "../Common/LabelStatus";
import classNames from "classnames";
import { getFileName, getFinalStatus } from "src/utils/common";
import PackageIcon from "src/assets/images/package.png";
import APP_ROUTES from "src/routes/routes";
import truncate from "lodash/truncate";
import ProtectedComponent from "../Permission";

const getInstanceDetailUrl = (id, page, condition) => {
  const baseUrl = `${APP_ROUTES.PROJECT_INSTANCE}/${id}`;
  const queryParams = [];

  if (page) {
    queryParams.push(`page=${page}`);
  }

  if (condition) {
    queryParams.push(`condition=${condition}`);
  }

  return queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;
};

const LabelStatusCustom = ({ row, t }) => {
  const isShowTestPackageId =
    row?.latest_deployment?.test_package_input_id &&
    (row?.status === PROCESS_STATUS.RUNNING || row?.status === PROCESS_STATUS.DEPLOYING || row?.status === PROCESS_STATUS.DEPLOYED);

  const getFileNameNotDeployed = (row) => {
    const deploymentCreatedAt = row?.latest_deployment?.gg_deployment_created_at;
    const opiUpdateAt = row?.opi_update_at;
    const mdbUpdateAt = row?.mdb_update_at;
    const mdbSource = row?.mdb_source;
    const opiSource = row?.opi_source;

    if (!deploymentCreatedAt) return null;

    const isOpiNewer = opiUpdateAt && new Date(opiUpdateAt) > new Date(deploymentCreatedAt) && opiSource === FILE_SOURCES_DEPLOYMENT.CLOUD;
    const isMdbNewer = mdbUpdateAt && new Date(mdbUpdateAt) > new Date(deploymentCreatedAt) && mdbSource === FILE_SOURCES_DEPLOYMENT.CLOUD;

    if (isOpiNewer && isMdbNewer) {
      return `${getFileName(row?.opi_s3_key)}, ${getFileName(row?.mdb_s3_key)}`;
    }

    if (isOpiNewer) {
      return getFileName(row?.opi_s3_key);
    }

    if (isMdbNewer) {
      return getFileName(row?.mdb_s3_key);
    }

    return null;
  };

  return (
    <LabelStatus
      row={row}
      staticTooltip={row?.latest_deployment?.error_message}
      showWarningIcon={row?.latest_deployment?.has_undeployed_changes && !!getFileNameNotDeployed(row)}
      warningContent={
        !!getFileNameNotDeployed(row) ? t("list.table.file_not_deployed_yet", { file_name: getFileNameNotDeployed(row) }) : ""
      }
      containerClass="instance-status"
      content={
        <>
          <span
            className={classNames({
              "m-b-4": row?.latest_deployment?.test_package_input_id && row?.status !== PROCESS_STATUS.ERROR,
            })}
          >
            {PROCESS_STATUS_NAME[getFinalStatus(row)]}
          </span>
          {isShowTestPackageId && <span>({truncate(row?.latest_deployment?.test_package_input_id, { length: 10 })})</span>}
        </>
      }
    />
  );
};

export const columns = ({ t, handleDeployClick, params, redirectToTestPackageList }) => [
  {
    dataField: "",
    text: t("list.table.id"),
    headerClass: "width-by-px-120",
    formatter: (_, row) => <span>{row?.increment_id || ""}</span>,
  },
  {
    dataField: "name",
    text: t("list.table.name"),
    headerClass: "width-by-px-160",
    formatter: (name) => <ShowDataCell data={name} customClass="text-nowrwap" />,
  },
  {
    dataField: "status",
    text: t("list.table.status"),
    headerClass: "width-by-px-130",
    formatter: (_, row) => <LabelStatusCustom row={row} t={t} />,
  },
  {
    dataField: "created_by_name",
    text: t("list.table.created_by_name"),
    headerClass: "width-by-px-160",
    formatter: (name) => <ShowDataCell data={name} />,
  },
  {
    dataField: "mdb_update_at",
    text: t("list.table.mdb_update_at"),
    headerClass: "width-by-px-110",
    formatter: (_, row) => <span>{row?.mdb_update_at || ""}</span>,
  },
  {
    dataField: "opi_update_at",
    text: t("list.table.opi_update_at"),
    headerClass: "width-by-px-110",
    formatter: (_, row) => <span>{row?.opi_update_at || ""}</span>,
  },
  {
    dataField: "updated_by_name",
    text: t("list.table.updated_by_name"),
    headerClass: "width-by-px-160",
    formatter: (name) => <ShowDataCell data={name} />,
  },
  {
    dataField: "updated_at",
    text: t("list.table.updated_at"),
    headerClass: "width-by-px-110",
    formatter: (_, row) => <span>{row?.updated_at || ""}</span>,
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => {
      const isDisable =
        !row?.mdb_s3_key ||
        !row?.opi_s3_key ||
        row?.status === PROCESS_STATUS.DEPLOYING ||
        row?.status === PROCESS_STATUS.RUNNING ||
        !row?.is_deploy_allowed;
      return (
        <>
          <ProtectedComponent id={`project_instance_deploy_${row.id}`}>
            <ButtonDeploy
              id={row.id}
              handleClick={() => handleDeployClick(row)}
              disabled={isDisable}
              tooltipText={isDisable ? "list.table.not_allowed_deploy" : "list.table.deploy"}
              translation="project-instance"
            />
          </ProtectedComponent>
          {/* <ButtonYamcsWebInterface id={row.id} isShow={row.status === PROCESS_STATUS.RUNNING} handleClick={() => {}} /> */}
        </>
      );
    },
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => (
      <TooltipWrapper id={`test_package_list-${row?.id}`} tooltipText={t("list.table.test_package_list")}>
        <button onClick={() => redirectToTestPackageList(row?.id)} className="btn btn-blank border-0 p-y-8 px-0">
          <img
            src={PackageIcon}
            className="width-by-px-20 heigth-by-px-24 text-dark-filter prevent-img-context-menu"
            alt="Test Package icon"
            onContextMenu={(e) => e.preventDefault()}
          />
        </button>
      </TooltipWrapper>
    ),
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60",
    formatter: (_, row) => <ButtonDetail id={row.id} toUrl={getInstanceDetailUrl(row?.id, params.page, params.condition)} />,
  },
];
